import styled from 'styled-components';

const membershipData = [
  {
    category: '',
    features: [
      {
        name: '서비스 접근',
        layout: false,
        availability: {
          Free: true,
          Standard: true,
          Premium: true,
        },
      },
      {
        name: '사건번호 검색',
        layout: false,
        availability: {
          Free: true,
          Standard: true,
          Premium: true,
        },
      },
    ],
  },
  {
    category: '경공매 검색 & 분석',

    features: [
      {
        name: '경공매 검색',
        layout: false,
        availability: {
          Free: false,
          Standard: true,
          Premium: true,
        },
      },
      {
        name: '지도 검색',
        layout: false,
        availability: {
          Free: false,
          Standard: true,
          Premium: true,
        },
      },
      {
        name: '부실채권 검색',
        layout: false,
        availability: {
          Free: false,
          Standard: true,
          Premium: true,
        },
      },
    ],
  },
  {
    category: '나만의 AI 분석',

    features: [
      {
        name: '땅집고 AI 추천 물건',
        layout: false,
        availability: {
          Free: false,
          Standard: true,
          Premium: true,
        },
      },
      {
        name: '내 알고리즘 분석',
        layout: false,
        availability: {
          Free: false,
          Standard: true,
          Premium: true,
        },
      },
      {
        name: '내 알고리즘 목록',
        layout: false,
        availability: {
          Free: false,
          Standard: true,
          Premium: true,
        },
      },
      {
        name: '퀀트 테마주',
        layout: false,
        availability: {
          Free: false,
          Standard: false,
          Premium: true,
        },
      },
    ],
  },
  {
    category: '12가지 퀀트 전략',

    features: [
      {
        name: '퀀트 테마주',
        layout: false,
        availability: {
          Free: false,
          Standard: true,
          Premium: true,
        },
      },
      {
        name: '경매 물건정보 공개',
        layout: true,
        availability: {
          Free: false,
          Standard: true,
          Premium: true,
        },
      },
      {
        name: '추천 건수',
        layout: true,
        availability: {
          Free: '회원가입일 2건 퀀트 상세 맛보기',
          Standard: '월 10건 퀀트 상세 맛보기',
          Premium: '월 120건 퀀트 상세 열람',
        },
      },
      {
        name: 'VIP 투자보고서',
        layout: true,
        availability: {
          Free: false,
          Standard: '월 1건 제공',
          Premium: '월 120건 제공',
        },
      },
    ],
  },
  {
    category: '하이라이트 VIP 경매 기사',
    features: [
      {
        name: '금주 VIP 경매 기사',
        layout: false,
        availability: {
          Free: true,
          Standard: true,
          Premium: '기사 출고 3일 전 미리보기 제공',
        },
      },
      {
        name: '전주 VIP 경매 기사',
        layout: false,
        availability: {
          Free: true,
          Standard: true,
          Premium: true,
        },
      },
    ],
  },
  {
    category: '낙찰 통계',
    features: [
      {
        name: '경공매 낙찰 통계',
        layout: false,
        availability: {
          Free: '광역시/도',
          Standard: '광역시/도/시/군/구',
          Premium: '광역시/도/시/군/구/읍/면/동',
        },
      },
      {
        name: '부실채권 낙찰 통계',
        layout: false,
        availability: {
          Free: '광역시/도',
          Standard: '광역시/도/시/군/구',
          Premium: '광역시/도/시/군/구/읍/면/동',
        },
      },
    ],
  },
];

const formatAvailability = (value: boolean | string) => {
  if (typeof value === 'boolean') {
    return value ? (
      <img
        src="/assets/images/check/blue_check_32.svg"
        alt="사용 가능"
        style={{ width: '20px', height: '20px' }}
      />
    ) : (
      <img
        src="/assets/images/arrow/gray_none_32.svg"
        alt="사용 불가"
        style={{ width: '20px', height: '20px' }}
      />
    );
  }
  return value;
};

interface MembershipDetailProps {
  selectedMembership: 'Free' | 'Standard' | 'Premium';
}

const MembershipDetail = ({ selectedMembership }: MembershipDetailProps) => {
  return (
    <div style={{ marginTop: '24px' }}>
      <Header>
        <Name>멤버십</Name>
        <HeaderContent>{selectedMembership}</HeaderContent>{' '}
      </Header>

      {membershipData.map((data) => (
        <Content key={data.category}>
          {data.category ? (
            <CategoryTitle>{data.category}</CategoryTitle>
          ) : null}
          {data.features.map((feature) => (
            <FeatureRow key={feature.name}>
              <FeatureName>
                {feature.layout && (
                  <img
                    src="/assets/images/arrow/gray_down_12.svg"
                    alt="layout icon"
                    style={{ width: '12px', height: '12px', marginTop: '3px' }}
                  />
                )}
                {feature.name}
              </FeatureName>

              <FeatureValue>
                {formatAvailability(feature.availability[selectedMembership])}
              </FeatureValue>
            </FeatureRow>
          ))}
        </Content>
      ))}
    </div>
  );
};

export default MembershipDetail;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e8ea;
  padding: 12px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  //   padding: 12px;
`;

const HeaderContent = styled.div`
  font-size: 14px;
  font-weight: 700;
  text-align: center;
`;

const Name = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;

const CategoryTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  padding: 16px;
  border-bottom: 1px solid #e5e8ea;
`;

const FeatureRow = styled.div`
  width: 100%;
  display: flex;
  padding: 12px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e8ea;
`;

const FeatureName = styled.div`
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const FeatureValue = styled.div`
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
`;
